export const monitoring_general = {
  index: {
    title: 'Monitoring'
  },

  tooltip: {
    index: 'Monitoring is available for active campaigns'
  }
};